import { render, staticRenderFns } from "./info.vue?vue&type=template&id=dc40e6a0&scoped=true&"
var script = {}
import style0 from "./info.vue?vue&type=style&index=0&id=dc40e6a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc40e6a0",
  null
  
)

export default component.exports